<template>
  <div id="app">
    <Toast />
    <AcknowledgeHandoff
      :showmodal="showmodal"
      :data="socketdata"
      @acknowledged="
        showAcknowledged = true;
        showmodal = false;
      "
      @declined="showmodal = false"
      @close-modal="showmodal = false"
    />
    <AcknowledegedHandoff ref="ackdes" @close-modal="closeAcknowledged()" :showAcknowledged="showAcknowledged" :data="socketdata" />
    <transition class="slide">
      <router-view />
    </transition>
  </div>
</template>

<script>
import Toast from "./components/UI/Toast.vue";
import AcknowledgeHandoff from "./components/3pl/Operations/Bookings/Modals/AcknowledgeHandoff.vue";
import AcknowledegedHandoff from "./components/3pl/Operations/Bookings/Modals/AcknowledegedHandoff.vue";

export default {
  name: "App",
  components: { Toast, AcknowledgeHandoff, AcknowledegedHandoff },
  data() {
    return {
      showmodal: false,
      socketdata: {},

      showAcknowledged: false,
    };
  },
  // computed: {
  //   isIdle() {
  //     return this.$store.state.idleVue.isIdle;
  //   },
  // },
  sockets: {
    connect: function () {
      console.log("SOcket has connected");
    },
    message: function (data) {
      this.processSocket(data);
    },
  },
  methods: {
    processSocket(data) {
      this.socketdata = data;

      if (
        data.app == "muleex" &&
        data.event == "process:fulfillment" &&
        data.message.destination.userId ==
          this.$store.state.authentication.userId
      ) {
        this.showmodal = true;
      } else if (
        data.app == "muleex" &&
        data.event == "process:handoff" &&
        data.message.destination.userId ==
          this.$store.state.authentication.userId
      ) {
        this.showmodal = true;
      }
    },
    closeAcknowledged(){
      this.showAcknowledged = false
    }
  },
  // watch: {
  //   isIdle(newval) {
  //     if (newval == true) {
  //       localStorage.clear();
  //       this.$router.push({
  //         name: "Home",
  //       });
  //     }
  //   },
  // },
};
</script>

<style>
:root {
  --primaryblue: #10233e;
  --lightblue: #f2f7fc;
  --amber: #f7b643;
  --carolinablue: #0f9cda;
}

body {
  scroll-behavior: smooth;
}
.slide-enter-active,
.slide-leave-active {
  transition: all ease-in-out 1s;
}
.slide-enter {
  transform: translate(-100%, 0);
}

.slide-leave-to {
  transform: translate(-100%, 0);
}
.modal-title {
  color: #b7bdcd;
  font-size: 16px;
}
.text-status {
  color: #09b78a;
}

.title-modal {
  color: #fcc210;
}
</style>
